import $ from "jquery";

export default function initUnsubscribe(autoSave) {
    const $form = $(".unsubscribe__form");
    const $unsubAllForm = $(".unsubscribe-all__form");
    const $btn = $(".unsubscribe__footer .btn");
    const $banner = $(".unsubscribe__banner");

    function hideBanner() {
        setTimeout(() => {
            $banner.fadeOut();
        }, 2000);
    }

    function savePrefs() {
        $banner.fadeOut();
        $btn.loading(true);

        return $.ajax({
            url: window.location.href,
            method: "POST",
            data: $form.serializeHash(),
        }).done(() => {
            $btn.loading(false);
        });
    }

    if ($banner.is(":visible")) {
        hideBanner();
    }

    $form.on("submit", () => {
        savePrefs().done(() => {
            $banner.fadeIn(hideBanner);
        });
        return false;
    });

    let preventResubmit = false;
    $unsubAllForm.on("submit", (event) => {
        if (preventResubmit) {
            event.preventDefault();
        }

        preventResubmit = true;
    });

    if (autoSave) {
        $("#auto-save-modal").modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });

        setTimeout(savePrefs, 500);
    }
}
